/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_sjA0fKs4Z",
    "aws_user_pools_web_client_id": "6r28pvhnb7s934skgs95o4i38s",
    "oauth": {
        "domain": "login.presagetech.com.auth.us-east-1.amazoncognito.com",
        "scope": [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "https://app.presagetech.com/,https://app.presagetech.com/admin/auth/callback,https://app.presagetech.com/auth/desktop-callback/index.html,https://app.presagetech.com/liveline/auth/callback,https://app.presagetech.com/portal/auth/callback,https://login.presagetech.com/,presage-vcam://auth/callback,presagevitals://auth/callback",
        "redirectSignOut": "https://app.presagetech.com/admin/logout,https://app.presagetech.com/liveline/logout,https://app.presagetech.com/logout,https://app.presagetech.com/portal/logout,https://login.presagetech.com/login",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
